module.exports = __webpack_public_path__ + "img/blur2.f77f6b21.webp";